import { render, staticRenderFns } from "./social.vue?vue&type=template&id=03ec6a70&"
import script from "./social.vue?vue&type=script&lang=js&"
export * from "./social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ec6a70')) {
      api.createRecord('03ec6a70', component.options)
    } else {
      api.reload('03ec6a70', component.options)
    }
    module.hot.accept("./social.vue?vue&type=template&id=03ec6a70&", function () {
      api.rerender('03ec6a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/social.vue"
export default component.exports